import MainOpenHouses from "../components/open-houses/main-open-houses";

export default function OpenHouses() {
  return <MainOpenHouses />;
}
